import { useMemo } from 'react';
import { useGetMyCompanyQuery } from '../../shared/redux/company';

export const useIsStangelandMaskin = () => {
  const { data: currentCompany } = useGetMyCompanyQuery();
  // QUESTION: Should this be added as a company setting?
  const isStangelandMaskin = useMemo(() => currentCompany?.name === 'STANGELAND MASKIN AS', [currentCompany]);

  return isStangelandMaskin;
};
